export default "__VITE_ASSET__C_ERwb8a__"